import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField } from 'fields';
import { useField } from 'formik';
import { calculateCropQuantityFromPacks } from 'utils';

export default function PackNumber() {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'ProductForm' });
  const [{ value: productData = {} }] = useField('productData');
  const [{ value: packagedItemReference = '' }] = useField('packagedItemReference');
  const [, , { setValue: setQuantity }] = useField('quantity');
  const disabled = !packagedItemReference;

  const handlePackNumberChange = useCallback(
    async (value) => {
      const quantity = calculateCropQuantityFromPacks(Number(value), { productData });
      await setQuantity(quantity || '');
    },
    [productData, setQuantity],
  );

  return (
    <TextField
      name="packagedItemQty"
      label={t('labels.packNumber')}
      placeholder={t('placeholders.packNumber')}
      required
      disabled={disabled}
      handleChangeCb={handlePackNumberChange}
    />
  );
}
